import {
  Text,
  Heading,
  Stack,
  Inline,
  Box,
  Divider,
  Column,
  Columns,
  Alert,
  CheckboxStandalone,
  Strong,
} from 'braid-design-system';
import React from 'react';

import { ListingProductCode } from 'src/generated/graphql';
import type { ProductBundle } from 'src/types/productBundle';
import {
  BOOST_BUNDLE_DISCOUNT_FEATURE_TOGGLE_ENABLED,
  getBoostBundlePrices,
} from 'src/utils/feature-flags';

interface AddOnsProps {
  isListingLus: boolean;
  productBundle: ProductBundle;
  searchBoostChecked: boolean;
  onSearchBoostToggle: () => void;
}

const AddOns = ({
  isListingLus,
  productBundle,
  searchBoostChecked,
  onSearchBoostToggle,
}: AddOnsProps) => {
  if (!productBundle.boostComponents?.search) {
    return (
      <Alert tone="critical">
        <Text>There&apos;s an issue displaying add-ons</Text>
      </Alert>
    );
  }

  let price;
  if (
    BOOST_BUNDLE_DISCOUNT_FEATURE_TOGGLE_ENABLED &&
    (productBundle.info.productCode === ListingProductCode.EmailBoost ||
      productBundle.info.productCode === ListingProductCode.EmailBoostLus)
  ) {
    price =
      getBoostBundlePrices({
        isLus: isListingLus,
      }).discountedSearchBoost / 100;
  } else {
    price = productBundle.boostComponents.search.cost / 100;
  }

  return (
    <Box data={{ testid: 'search-boost-add-on' }}>
      <Stack space="medium">
        <Heading level="4">Add-ons</Heading>

        <Divider />

        <Columns space="small">
          <Column width="content">
            <CheckboxStandalone
              id={searchBoostCheckboxId}
              aria-labelledby={searchBoostCheckboxLabelId}
              data={{ testid: 'search-boost-checkbox' }}
              checked={searchBoostChecked}
              onChange={onSearchBoostToggle}
              size="small"
            />
          </Column>
          <Column>
            <Stack space="small">
              <Box
                component="label"
                cursor="pointer"
                userSelect="none"
                id={searchBoostCheckboxLabelId}
                htmlFor={searchBoostCheckboxId}
              >
                <Inline alignY="center" space="small">
                  <Heading level="4">Search Boost</Heading>

                  <Inline alignY="bottom" space="xxsmall">
                    <Heading level="4">${price}</Heading>
                    <Text size="small" weight="strong">
                      + GST
                    </Text>
                  </Inline>
                </Inline>
              </Box>

              <Text tone="secondary" size="small">
                Your ad is featured at the top of relevant search results pages.
                Boosted ads <Strong>on average receive 50%</Strong> more
                enquiries.
              </Text>
            </Stack>
          </Column>
        </Columns>

        <Divider />
      </Stack>
    </Box>
  );
};

const searchBoostCheckboxId = 'checkout-payment-search-boost-checkbox';
const searchBoostCheckboxLabelId =
  'checkout-payment-search-boost-checkbox-label';

export default AddOns;
